"use strict";
// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/spwn_ec/v1/legacy_portal_service.proto (package spwn.spwn_ec.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegacyPortalSpwnEcService = void 0;
const legacy_portal_service_pb_1 = require("./legacy_portal_service_pb");
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * @generated from service spwn.spwn_ec.v1.LegacyPortalSpwnEcService
 */
exports.LegacyPortalSpwnEcService = {
    typeName: "spwn.spwn_ec.v1.LegacyPortalSpwnEcService",
    methods: {
        /**
         * 指定したイベントのライブコマース商品すべてを Shopify から取得する
         *
         * @generated from rpc spwn.spwn_ec.v1.LegacyPortalSpwnEcService.GetAllLiveCommerceProductsByEventId
         */
        getAllLiveCommerceProductsByEventId: {
            name: "GetAllLiveCommerceProductsByEventId",
            I: legacy_portal_service_pb_1.LegacyPortalSpwnEcServiceGetAllLiveCommerceProductsByEventIdRequest,
            O: legacy_portal_service_pb_1.LegacyPortalSpwnEcServiceGetAllLiveCommerceProductsByEventIdResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * ライブコマースのカートを、指定した内容に一致させる
         *
         * @generated from rpc spwn.spwn_ec.v1.LegacyPortalSpwnEcService.SyncLiveCommerceCart
         */
        syncLiveCommerceCart: {
            name: "SyncLiveCommerceCart",
            I: legacy_portal_service_pb_1.LegacyPortalSpwnEcServiceSyncLiveCommerceCartRequest,
            O: legacy_portal_service_pb_1.LegacyPortalSpwnEcServiceSyncLiveCommerceCartResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
    }
};
//# sourceMappingURL=legacy_portal_service_connect.js.map